import React, { useEffect, useRef, useState } from "react";
import { ZegoExpressEngine } from "zego-express-engine-webrtc";
import { GetStreamToken } from "../../services/cms.service";
import { GetLiveCaptions, getLiveStreamProducts, endStream, getStreamDetails, getStreamComments } from "../../services/stream.service";
import { GetVertexAi } from "../../services/vertex.services";
import { profileDetails } from "../../services/user.service";
import { SOCKET_CLIENT } from "../../../../utils/socket";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { SWAL_SETTINGS, SOCKET_EVENTS, ROLE } from "../../../../utils/Constants";
import { getUser } from "../../../../utils/commonfunction";
import { Mic, MicOff, ThumbsUp, MessageCircle, Eye, Send, MessageCircleOff, Camera, CornerDownRight } from "lucide-react";
import { useSelector } from "react-redux";
import Hls from "hls.js";
const appID = Number(process.env.REACT_APP_ZEGO_APP_ID);
const server = process.env.REACT_APP_ZEGO_server;

const FRAME_BATCH_SIZE = 1;
const CAPTURE_INTERVAL = 10000;

const showStreamNotification = (icon, title, text) => {
  Swal.fire({
    icon,
    title,
    text,
    toast: true,
    position: "top-end",
    timer: 5000,
    showConfirmButton: false,
    timerProgressBar: true,
    customClass: { container: "stream-toast" },
    didOpen: (toast) => {
      const container = toast.closest(".swal2-container");
      if (container) container.style.zIndex = "99999";
    },
  });
};

function LiveStreamDetail() {
  const { userID, roomID, streamId } = useParams();
  const publisherStreamId = `stream_${streamId}`;
  const engineRef = useRef(null);
  const hlsRef = useRef(null);
  const localStreamRef = useRef(null);
  const [streamMeta, setStreamMeta] = useState(null);
  const countdownRef = useRef(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const startTimeRef = useRef(null);
  const [sellerMeta, setSellerMeta] = useState(null);

  console.log(sellerMeta, "ads12121");

  const sttSocketRef = useRef(null);
  const userName = `User_${userID}`;
  const navigate = useNavigate();
  const [showComments, setShowComments] = useState(true);
  const localVideoRef = useRef(null);

  const canvasRef = useRef(null);
  const lastFrameDataRef = useRef(null);
  const frameBufferRef = useRef([]);
  const captureTimerRef = useRef(null);

  const audioRecorderRef = useRef(null);
  const micStreamRef = useRef(null);
  const streamStartedRef = useRef(false);

  const [engine, setEngine] = useState(null);
  const [localStream, setLocalStream] = useState(null);
  const [isStreaming, setIsStreaming] = useState(false);
  const [products, setProducts] = useState([]);

  const [liveCaption, setLiveCaption] = useState("");
  const selectedLang = useSelector((state) => state.globalData.lang);
  const [commentLists, setCommentLists] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [replyTarget, setReplyTarget] = useState(null); // { commentId, senderId, senderName }
  const [replyMessage, setReplyMessage] = useState("");
  const [totalLiked, setTotalLiked] = useState(0);
  const [totalViewers, setTotalViewers] = useState(0);
  const chatContainerRef = useRef(null);
  const [isMuted, setIsMuted] = useState(false);
  const mobileScrollRef = useRef(null);
  const desktopScrollRef = useRef(null);

  useEffect(() => {
    const handleWheel = (e) => {
      const elements = [mobileScrollRef.current, desktopScrollRef.current].filter(Boolean);

      for (const el of elements) {
        const rect = el.getBoundingClientRect();

        const isInside =
          e.clientX >= rect.left &&
          e.clientX <= rect.right &&
          e.clientY >= rect.top &&
          e.clientY <= rect.bottom;

        if (isInside) {
          const canScroll = el.scrollWidth > el.clientWidth;
          if (!canScroll) continue;

          const atStart = el.scrollLeft <= 0;
          const atEnd = Math.ceil(el.scrollLeft + el.clientWidth) >= el.scrollWidth - 1;

          const scrollingDown = e.deltaY > 0;
          const scrollingUp = e.deltaY < 0;

          // Allow page scroll at edges
          if ((atStart && scrollingUp) || (atEnd && scrollingDown)) {
            continue;
          }

          e.preventDefault();
          el.scrollLeft += e.deltaY;
          break;
        }
      }
    };

    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  useEffect(() => {
    if (chatContainerRef.current) {
      requestAnimationFrame(() => {
        setTimeout(() => {
          if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
          }
        }, 0);
      });
    }
  }, [commentLists]);

  const handleSend = () => {
    if (!inputMessage.trim()) return;
    SOCKET_CLIENT.emit(SOCKET_EVENTS.COMMENTED, {
      senderID: userID,
      streamID: streamId,
      message: inputMessage.trim(),
    });
    setInputMessage("");
  };

  const handleSendReply = () => {
    if (!replyMessage.trim() || !replyTarget) return;

    // Add the reply to the local chat so the streamer can see it immediately
    setCommentLists((prev) => [
      ...prev,
      {
        message: replyMessage.trim(),
        userData: sellerMeta,
        senderId: userID,
        isPrivateReply: true,
        replyToMessage: replyTarget.message,
        createdAt: new Date().toISOString(),
      },
    ]);

    SOCKET_CLIENT.emit(SOCKET_EVENTS.STREAMER_REPLY, {
      senderID: userID,
      targetUserID: replyTarget.senderId,
      streamID: streamId,
      message: replyMessage.trim(),
      replyToCommentId: replyTarget.commentId,
    });
    setReplyMessage("");
    setReplyTarget(null);
  };
  // ------------------------------------------------------
  // Motion based frame capture
  // ------------------------------------------------------
  const fetchStreamMeta = async () => {
    try {
      const resp = await getStreamDetails(streamId);
      if (resp.success && resp.data) {
        console.log("Stream Meta Fetched:", resp.data);
        setStreamMeta(resp.data);
        if (resp.data.listOfViewers?.length !== undefined) {
          setTotalViewers(resp.data.listOfViewers.length);
        }
        if (resp.data.listOfLikedUsers?.length !== undefined) {
          setTotalLiked(resp.data.listOfLikedUsers.length);
        }
      }
    } catch (error) {
      console.error("Failed to fetch stream meta:", error);
    }
  };

  const fetchComments = async () => {
    try {
      const resp = await getStreamComments(streamId);
      if (resp.success && Array.isArray(resp.data?.comments)) {
        const mapped = resp.data.comments.map((c) => ({
          _id: c._id,
          message: c.message,
          title: c.message, // Keep title for backward compatibility if used anywhere
          userData: c.sender,
          senderId: c.sender?._id,
          isPrivateReply: c.isPrivateReply,
          replyToMessage: c.replyToMessage,
          createdAt: c.createdAt,
        }));
        setCommentLists((prev) => prev.length === 0 ? mapped : [...mapped, ...prev]);
      }
    } catch (error) {
      console.error("Failed to fetch comments:", error);
    }
  };

  const fetchSellerMeta = async () => {
    try {
      const userData = getUser(ROLE.ADVERTISER) || {};
      const resp = await profileDetails({ _id: userData._id });
      if (resp.success && resp.data) {
        setSellerMeta(resp.data);
      }
    } catch (error) {
      console.error("Failed to fetch seller meta:", error);
    }
  };

  useEffect(() => {
    fetchStreamMeta();
    fetchSellerMeta();
  }, []);

  // -------------------------------------------------------
  // Socket: Join seller + stream room for notifications
  // -------------------------------------------------------
  useEffect(() => {
    if (!userID || !streamId) return;

    const joinRooms = () => {
      console.log("🔌 Joining rooms:", userID, streamId);
      // Join seller's personal room (for NEW_LEAD via GET-DATA)
      SOCKET_CLIENT.emit("join_stream_room", userID);
      // Join stream room (for SAFETY_FLAG_DETECTED direct emit)
      SOCKET_CLIENT.emit("join_stream_room", streamId);
      SOCKET_CLIENT.on(SOCKET_EVENTS.NEW_PRODUCT, (data) => {
        console.log("🎁 New product received via socket:", data);
        if (data && data.product) {
          setProducts((prev) => {
            // Check if product already exists to avoid duplicates
            const exists = prev.some(p => p._id === data.product._id);
            if (exists) return prev;
            return [data.product, ...prev];
          });
        }
      });
      SOCKET_CLIENT.on(SOCKET_EVENTS.PRODUCT_REMOVED, (data) => {
        console.log("🚫 Product removed via socket:", data);
        if (data && data.productID) {
          setProducts((prev) => prev.filter(p => p._id !== data.productID));
        }
      });
      SOCKET_CLIENT.emit(SOCKET_EVENTS.JOIN_STREAM, {
        streamID: streamId,
        userId: userID,
        role: "user",
      });
    };

    // Fetch existing comments from API
    fetchComments();

    // Join now (if already connected)
    if (SOCKET_CLIENT.connected) {
      joinRooms();
    }

    // Also join on reconnect
    SOCKET_CLIENT.on("connect", joinRooms);

    // NEW_LEAD arrives via GET-DATA envelope
    const handleGetData = (payload) => {
      console.log("📨 GET-DATA received:", payload);
      if (payload?.event === "NEW_LEAD") {
        showStreamNotification("success", "New Lead! 🎉", payload?.message || "A new lead was created.");
      }
    };

    // SAFETY_FLAG_DETECTED is emitted directly on the stream room
    const handleSafetyFlag = (payload) => {
      console.log("⚠️ Safety flag received:", payload);
      const streamName = payload?.streamName ? ` "${payload.streamName}"` : "";
      showStreamNotification("warning", "Safety Flag ⚠️", `A product was flagged for safety issues in the live stream${streamName}.`);
    };

    SOCKET_CLIENT.on("GET-DATA", handleGetData);
    SOCKET_CLIENT.on("SAFETY_FLAG_DETECTED", handleSafetyFlag);

    SOCKET_CLIENT.on(SOCKET_EVENTS.NEW_COMMENT, (comment) => {
      setCommentLists((prev) => [
        ...prev,
        {
          message: comment?.message,
          title: comment?.message,
          userData: comment?.sender,
          senderId: comment?.sender?._id,
          isPrivateReply: comment?.isPrivateReply,
          replyToMessage: comment?.replyToMessage,
          createdAt: comment?.createdAt || new Date().toISOString(),
        },
      ]);
    });


    SOCKET_CLIENT.on("live_caption", (data) => {
      console.log("Received caption via socket:", data);
      if (data?.transcript && data.transcript !== "[System: STT Processing Started]") {
        // Broadcaster should usually see their own spoken language or the selected lang
        if (data.language === selectedLang) {
          setLiveCaption(data.transcript);
        }
      }
    });

    SOCKET_CLIENT.on(SOCKET_EVENTS.LIVE_CAPTION_TEXT, (data) => {
      // Keep for backward compatibility if needed, but primary is live_caption
      if (data?.transcript && data.transcript !== "[System: STT Processing Started]") {
        setLiveCaption(data.transcript);
      }
    });
    SOCKET_CLIENT.on("STREAM_ENDED_BY_ADMIN", (data) => {
      console.log("🛑 Stream ended by admin:", data);

      stopStream(true);

      Swal.fire({
        icon: "warning",
        title: "Stream Ended",
        text: "Your stream has been ended by the administrator.",
        timer: 2000,
        showConfirmButton: false,
      });
    });
    SOCKET_CLIENT.on(SOCKET_EVENTS.STREAM_VIEWER_COUNT, (data) => {
      console.log("STREAM_VIEWER_COUNT received:", data);
      if (data?.totalLikes !== undefined) setTotalLiked(data.totalLikes);
      const viewsCount = data?.totalDbViews !== undefined ? data.totalDbViews : (data?.totalViews !== undefined ? data.totalViews : data?.totalViewers);
      if (viewsCount !== undefined) setTotalViewers(viewsCount);
    });

    SOCKET_CLIENT.on(SOCKET_EVENTS.STREAM_LIKE_UPDATE, (data) => {
      if (data?.totalLikes !== undefined) setTotalLiked(data.totalLikes);
    });

    const handleAiClicksUpdate = (data) => {
      console.log("AI_CLICKS_UPDATED received:", data);
      const remaining = typeof data === "object" ? (data?.remaining_ai_clicks ?? data?.clicks) : data;
      if (remaining !== undefined) {
        setStreamMeta((prev) => {
          if (!prev) return prev;
          return {
            ...prev,
            remaining_ai_clicks: remaining,
            seller: {
              ...(prev.seller || {}),
              remaining_ai_clicks: remaining,
            },
          };
        });
      }
    };
    SOCKET_CLIENT.on(SOCKET_EVENTS.AI_CLICKS_UPDATED, handleAiClicksUpdate);

    return () => {
      SOCKET_CLIENT.emit(SOCKET_EVENTS.LEAVE_STREAM, {
        streamID: streamId,
        userId: userID,
        role: "user",
      });

      SOCKET_CLIENT.off("connect", joinRooms);
      SOCKET_CLIENT.off("GET-DATA", handleGetData);
      SOCKET_CLIENT.off("SAFETY_FLAG_DETECTED", handleSafetyFlag);
      SOCKET_CLIENT.off(SOCKET_EVENTS.NEW_COMMENT);
      SOCKET_CLIENT.off(SOCKET_EVENTS.LIVE_CAPTION_TEXT);
      SOCKET_CLIENT.off(SOCKET_EVENTS.NEW_PRODUCT);
      SOCKET_CLIENT.off(SOCKET_EVENTS.STREAM_VIEWER_COUNT);
      SOCKET_CLIENT.off(SOCKET_EVENTS.STREAM_LIKE_UPDATE);
      SOCKET_CLIENT.off(SOCKET_EVENTS.AI_CLICKS_UPDATED, handleAiClicksUpdate);
    };
  }, [userID, streamId]);

  const captureScreenshot = () => {
    const video = localVideoRef.current;
    const canvas = canvasRef.current;

    if (!video || !canvas || video.videoWidth === 0 || video.videoHeight === 0) return;

    const remainingClicks = streamMeta?.remaining_ai_clicks ?? streamMeta?.seller?.remaining_ai_clicks;
    if (remainingClicks !== undefined && remainingClicks <= 0) {
      showStreamNotification("warning", "Insufficient AI Clicks", "Insufficient AI clicks. Please purchase more.");
      return;
    }

    const ctx = canvas.getContext("2d");

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    const base64Image = canvas.toDataURL("image/jpeg", 0.7);

    sendFramesToBackend([base64Image]);
    showStreamNotification("success", "Screenshot Sent", "Frame sent to AI successfully.");
  };

  const sendFramesToBackend = async (frames) => {
    console.log('Sending frames to Vertex AI');
    try {
      await GetVertexAi({
        frames,
        seller_id: userID || streamMeta?.seller?._id || streamMeta?.seller_id,
        stream_id: streamId,
      });
    } catch (error) {
      console.error("❌ Error sending frames:", error);
    }
  };

  const startLiveCaptions = async () => {
    try {
      const stream = micStreamRef.current;
      if (!stream) return;

      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      await audioContext.resume();

      const sampleRate = audioContext.sampleRate;
      console.log("Actual Sample Rate:", sampleRate);

      const wsUrl = `${process.env.REACT_APP_STT_WS_URL}?language=${selectedLang}&streamId=${streamId}&sampleRate=${sampleRate}`;
      const ws = new WebSocket(wsUrl);

      ws.binaryType = "arraybuffer"; // ⭐ IMPORTANT
      sttSocketRef.current = ws;

      ws.onopen = async () => {
        console.log("✅ STT socket connected");

        const source = audioContext.createMediaStreamSource(stream);

        // ⭐ Use AudioWorklet instead of ScriptProcessor
        await audioContext.audioWorklet.addModule("/pcm-worklet.js");

        const worklet = new AudioWorkletNode(audioContext, "pcm-processor");

        source.connect(worklet);
        worklet.connect(audioContext.destination);

        worklet.port.onmessage = (event) => {
          if (ws.readyState === WebSocket.OPEN) {
            ws.send(event.data); // already Int16 PCM
          }
        };
      };

      ws.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.transcript) setLiveCaption(data.transcript);
      };

      ws.onerror = (err) => console.error("❌ STT socket error:", err);
      ws.onclose = () => console.log("🔴 STT socket closed");

    } catch (err) {
      console.error("STT start error:", err);
    }
  };

  useEffect(() => {
    if (isStreaming) {
      console.log("♻️ Restarting STT for language:", selectedLang);
      stopLiveCaptions();
      startLiveCaptions();
    }
  }, [selectedLang]);


  function convertFloatToInt16(float32Array) {
    const buffer = new ArrayBuffer(float32Array.length * 2);
    const view = new DataView(buffer);

    let offset = 0;
    for (let i = 0; i < float32Array.length; i++, offset += 2) {
      let s = Math.max(-1, Math.min(1, float32Array[i]));
      view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
    }

    return buffer;
  }

  const stopLiveCaptions = () => {
    if (audioRecorderRef.current) {
      audioRecorderRef.current.stop();
      audioRecorderRef.current = null;
    }

    if (sttSocketRef.current) {
      sttSocketRef.current.close();
      sttSocketRef.current = null;
    }

    setLiveCaption("");
  };


  // ------------------------------------------------------
  // Fetch Products
  // ------------------------------------------------------

  const fetchProducts = async () => {
    try {
      const resp = await getLiveStreamProducts({ stream_id: streamId });
      if (resp.success) {
        setProducts((resp.data || []).filter(p => p.is_live_on_stream !== false && p.verified_by_staff !== false));
      }
    } catch (error) {
      console.error("❌ Error fetching live products:", error);
    }
  };
  useEffect(() => {
    if (!streamId) return;
    fetchProducts();
  }, [streamId]);

  // ------------------------------------------------------
  // Start stream
  // ------------------------------------------------------

  const startStream = async () => {
    console.log("check for starting streams");

    if (streamMeta?.stream_type === "recorded") {
      setIsStreaming(true);
      startLiveCaptions();
      if (localVideoRef.current && streamMeta.recording_url) {
        const video = localVideoRef.current;
        video.srcObject = null;

        if (streamMeta.recording_url.includes(".m3u8")) {
          if (Hls.isSupported()) {
            if (hlsRef.current) hlsRef.current.destroy();
            const hls = new Hls();
            hls.loadSource(streamMeta.recording_url);
            hls.attachMedia(video);
            hlsRef.current = hls;
          } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
            video.src = streamMeta.recording_url;
          }
        } else {
          video.src = streamMeta.recording_url;
        }

        video.controls = true;
        video.play().catch(e => console.log("Auto-play blocked:", e));
      }
      return;
    }

    try {
      // 1️⃣ Get browser mic stream
      const browserStream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });

      micStreamRef.current = browserStream; // ✅ KEEP THIS

      if (localVideoRef.current) {
        localVideoRef.current.srcObject = browserStream;
      }

      // 2️⃣ Init Zego
      const zg = new ZegoExpressEngine(appID, server);
      zg.setLogConfig({
        logLevel: "disable",
        remoteLogLevel: "disable",
      });
      engineRef.current = zg;
      setEngine(zg);

      const res = await GetStreamToken(userID, roomID);
      const token = res.token;

      await zg.loginRoom(roomID, token, { userID, userName });

      // 3️⃣ Create Zego publishing stream
      const zegoStream = await zg.createStream({
        camera: { video: true, audio: true },
      });

      // 🚫 DO NOT overwrite micStreamRef here
      // micStreamRef.current = zegoStream; ❌ REMOVE THIS

      zg.startPublishingStream(`stream_${streamId}`, zegoStream);
      localStreamRef.current = zegoStream;
      setLocalStream(zegoStream);

      // 4️⃣ Preview Zego stream (optional)
      if (localVideoRef.current) {
        localVideoRef.current.srcObject = zegoStream;
      }

      setIsStreaming(true);
      startTimeRef.current = Date.now();

      // 5️⃣ Start captions using REAL mic
      startLiveCaptions();

      console.log("✅ Stream started successfully");
    } catch (error) {
      console.error("❌ Error starting stream:", error);
    }
  };
  const stopLocalMediaImmediately = () => {
    // ✅ Stop mic + camera tracks
    if (micStreamRef.current) {
      micStreamRef.current.getTracks().forEach(track => {
        track.stop();
      });
      micStreamRef.current = null;
    }

    // ✅ Stop Zego local stream tracks
    if (localStreamRef.current) {
      localStreamRef.current.getTracks().forEach(track => {
        track.stop();
      });
    }

    // ✅ Clear video element completely
    if (localVideoRef.current) {
      const video = localVideoRef.current;

      if (video.srcObject) {
        video.srcObject.getTracks().forEach(track => track.stop());
      }

      video.pause();
      video.srcObject = null;
      video.src = "";
      video.load();
    }
  };
  const toggleMic = () => {
    const nextMuteState = !isMuted;

    // 1. Mute Zego Publisher
    if (engineRef.current && publisherStreamId) {
      engineRef.current.mutePublishStreamAudio(publisherStreamId, nextMuteState);
    }

    // 2. Mute Tracks in Mic Stream (STT)
    if (micStreamRef.current) {
      micStreamRef.current.getAudioTracks().forEach((track) => {
        track.enabled = !nextMuteState;
      });
    }

    // 3. Mute Tracks in Local Stream (Zego local)
    if (localStreamRef.current) {
      localStreamRef.current.getAudioTracks().forEach((track) => {
        track.enabled = !nextMuteState;
      });
    }

    // 4. Start/Stop STT WebSocket explicitly
    if (nextMuteState) {
      stopLiveCaptions();
    } else {
      startLiveCaptions();
    }

    setIsMuted(nextMuteState);
  };

  const cleanupEngine = async () => {
    try {
      const currentEngine = engineRef.current;
      const currentStream = localStreamRef.current;

      if (currentEngine && currentStream) {
        currentEngine.stopPublishingStream(`stream_${streamId}`);

        // ✅ EXTRA: ensure tracks stopped
        currentStream.getTracks().forEach(track => track.stop());

        currentEngine.destroyStream(currentStream);
        await currentEngine.logoutRoom(roomID);
        currentEngine.destroyEngine();
      }

      engineRef.current = null;
      localStreamRef.current = null;

    } catch (err) {
      console.error("Engine cleanup error:", err);
    }
    if (hlsRef.current) {
      hlsRef.current.destroy();
      hlsRef.current = null;
    }
  };

  const stopStream = async (endedByAdmin = false, isOfflineTrigger = false) => {
    try {
      if (countdownRef.current) {
        clearInterval(countdownRef.current);
        countdownRef.current = null;
      }

      stopLocalMediaImmediately();
      stopLiveCaptions();

      const performCleanupAndNavigate = () => {
        navigate("/advertiser/streams");
        setTimeout(async () => {
          await cleanupEngine();
        }, 0);
      };

      // 🚀 IF ADMIN ENDED OR OFFLINE → SKIP API INITIALLY
      if (endedByAdmin || isOfflineTrigger || !navigator.onLine) {
        performCleanupAndNavigate();

        if ((isOfflineTrigger || !navigator.onLine) && !endedByAdmin) {
          const endStreamWhenOnline = async () => {
            try {
              await endStream({ _id: streamId });
              console.log("Stream ended on backend after reconnecting.");
            } catch (err) {
              console.error("Failed to end stream on backend after reconnecting", err);
            } finally {
              window.removeEventListener("online", endStreamWhenOnline);
            }
          };
          window.addEventListener("online", endStreamWhenOnline);
        }

        return; // ✅ VERY IMPORTANT
      }

      // 👇 Normal flow (manual stop)
      try {
        const resp = await endStream({ _id: streamId });

        const success = resp?.success ?? resp?.data?.success;
        const message = resp?.message ?? resp?.data?.message;

        if (!success) {
          Swal.fire({
            icon: "error",
            text: message || "Failed to end stream",
            ...SWAL_SETTINGS,
          });
        }
      } finally {
        // ✅ ALWAYS Force cleanup to ensure Zego/camera is stopped!p.........
        performCleanupAndNavigate();
      }

    } catch (error) {
      console.error("❌ Error stopping stream:", error);

      Swal.fire({
        icon: "error",
        text: error?.response?.data?.message || "Something went wrong",
        ...SWAL_SETTINGS,
      });
      
      // ✅ Force cleanup even if a critical error occurs
      const performCleanupAndNavigate = () => {
        navigate("/advertiser/streams");
        setTimeout(async () => {
          await cleanupEngine();
        }, 0);
      };
      performCleanupAndNavigate();
    }
  };

  useEffect(() => {
    if (!isStreaming) return;

    let endTime;
    if (streamMeta?.streamEndAt) {
      endTime = new Date(streamMeta.streamEndAt).getTime();
    } else if (streamMeta?.duration && (streamMeta?.date || startTimeRef.current)) {
      const start = streamMeta.date ? new Date(streamMeta.date).getTime() : startTimeRef.current;
      endTime = start + (Number(streamMeta.duration) * 60 * 1000);
      console.log("Calculated End Time (duration fallback):", new Date(endTime).toLocaleString());
    }

    if (!endTime) return;

    const interval = setInterval(() => {
      const remaining = Math.max(0, endTime - Date.now());

      if (remaining <= 0) {
        clearInterval(interval);
        console.log("⏰ End time reached. Auto stopping stream.");
        stopStream();
        return;
      }

      setTimeLeft(Math.floor(remaining / 1000));
    }, 1000);

    return () => clearInterval(interval);

  }, [isStreaming, streamMeta?.streamEndAt, streamMeta?.duration, streamMeta?.date]);

  const formatTimeLeft = (seconds) => {
    if (seconds === null) return "--:--";
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  // ------------------------------------------------------
  // Internet connection handling
  // ------------------------------------------------------

  useEffect(() => {
    const handleOffline = () => {
      console.log("Internet connection lost. Stopping stream locally...");
      Swal.fire({
        icon: "warning",
        title: "Connection Lost",
        text: "Internet connection broken. Exiting stream screen...",
        toast: true,
        position: "top-end",
        timer: 5000,
        showConfirmButton: false,
        timerProgressBar: true,
      });
      stopStream(false, true);
    };

    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  // ------------------------------------------------------
  // Auto start stream
  // ------------------------------------------------------

  useEffect(() => {
    if (!streamMeta || streamStartedRef.current) return;
    streamStartedRef.current = true;

    if (streamMeta.stream_type === "recorded") {
      setIsStreaming(true);
      if (localVideoRef.current && streamMeta.recording_url) {
        const video = localVideoRef.current;
        video.srcObject = null;

        if (streamMeta.recording_url.includes(".m3u8")) {
          if (Hls.isSupported()) {
            if (hlsRef.current) hlsRef.current.destroy();
            const hls = new Hls();
            hls.loadSource(streamMeta.recording_url);
            hls.attachMedia(video);
            hlsRef.current = hls;
          } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
            video.src = streamMeta.recording_url;
          }
        } else {
          video.src = streamMeta.recording_url;
        }

        video.controls = true;
        video.play().catch(e => console.log("Auto-play blocked:", e));
      }
    } else {
      const t = setTimeout(startStream, 500);
      return () => clearTimeout(t);
    }
  }, [streamMeta]);



  // ------------------------------------------------------
  // Motion capture removed (now manual screenshot)
  // ------------------------------------------------------

  return (
    <div className="live-stream-detail py-10 pt-3">
      <canvas ref={canvasRef} style={{ display: "none" }} />

      <div className="container mx-auto px-4">
        <div className="relative z-10 w-full rounded-[20px] overflow-hidden aspect-[9/16] md:aspect-auto min-h-[220px] md:min-h-[500px] bg-black lg:h-[calc(100vh-120px)] flex items-center justify-center">
          <video ref={localVideoRef} autoPlay playsInline muted className="w-full h-full object-contain" style={{ background: "#000" }} />

          {liveCaption && (
            <div
              style={{
                position: "absolute",
                bottom: "86%",
                left: "50%",
                transform: "translateX(-50%)",
                maxWidth: "87%",
                padding: "8px 14px",
                background: "rgba(0,0,0,0.65)",
                color: "#fff",
                borderRadius: "8px",
                fontSize: "16px",
                textAlign: "center",
                pointerEvents: "none",
                lineHeight: "1.4",
                zIndex: 20,
              }}>
              {liveCaption}
            </div>
          )}

          {/* UI */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-black/20 to-black/60 flex p-[15px] gap-[30px] z-10">
            <div className="!absolute !top-0 !left-0 !w-full !h-[120px] !bg-gradient-to-t !from-transparent !via-black/20 !to-black/60 -z-1"></div>
            {/* MOBILE HEADER (match user Detail.js) */}
            <div className="lg:hidden absolute top-4 left-4 right-4 flex flex-col gap-2 z-20">
              <div className="flex items-center gap-2">
                <img
                  src={sellerMeta?.profile_image || sellerMeta?.store_image || "/images/User.png"}
                  onError={(e) => { e.target.onerror = null; e.target.src = '/images/User.png'; }}
                  alt="User"
                  className="w-8 h-8 rounded-full object-cover border border-white/30"
                />
                <div className="flex flex-col">
                  <span className="text-white text-sm font-semibold leading-tight">
                    {sellerMeta?.name || "Sarah Miller"}
                  </span>
                  <span className="text-white/70 text-[11px] leading-tight">
                    {sellerMeta?.store_name || "Sarah's Boutique"}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <span className="bg-red-600 text-white text-[11px] px-2.5 py-1 rounded-full">Live</span>
                <span className="bg-white text-black text-[11px] px-2.5 py-1 rounded-full flex items-center gap-1">
                  <img src="/images/eye5.svg" alt="eye" className="w-3.5 h-3.5" />
                  <span>{totalViewers} views</span>
                </span>
                {/* Like count */}
                <span className="bg-white text-black text-[11px] px-2.5 py-1 rounded-full flex items-center gap-1">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-[14px] h-[14px]"><path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"></path></svg> <span>{totalLiked} Likes</span>
                </span>
              </div>
            </div>



            {/* Desktop actions (match user Detail.js) */}
            <div className="hidden lg:flex absolute bottom-35 inset-x-0 justify-center items-center pointer-events-none z-50">
              <div className="flex items-center gap-4 pointer-events-auto">
                {/* Screenshot Button */}
                <button
                  onClick={captureScreenshot}
                  disabled={(streamMeta?.remaining_ai_clicks ?? streamMeta?.seller?.remaining_ai_clicks) !== undefined && (streamMeta?.remaining_ai_clicks ?? streamMeta?.seller?.remaining_ai_clicks) <= 0}
                  className={`w-11 h-11 rounded-full backdrop-blur-md flex items-center justify-center shadow-lg border transition-all duration-300 ${
                    (streamMeta?.remaining_ai_clicks ?? streamMeta?.seller?.remaining_ai_clicks) !== undefined && (streamMeta?.remaining_ai_clicks ?? streamMeta?.seller?.remaining_ai_clicks) <= 0
                      ? "bg-gray-500/20 border-gray-400/40 text-gray-400 opacity-50 cursor-not-allowed"
                      : "bg-white/10 border-white/20 text-white hover:bg-white/20 hover:scale-110 active:scale-95 cursor-pointer"
                  }`}
                  title={
                    (streamMeta?.remaining_ai_clicks ?? streamMeta?.seller?.remaining_ai_clicks) !== undefined && (streamMeta?.remaining_ai_clicks ?? streamMeta?.seller?.remaining_ai_clicks) <= 0
                      ? "Insufficient AI Clicks"
                      : (streamMeta?.remaining_ai_clicks ?? streamMeta?.seller?.remaining_ai_clicks) !== undefined
                        ? `Capture Screenshot (${streamMeta?.remaining_ai_clicks ?? streamMeta?.seller?.remaining_ai_clicks} AI clicks left)`
                        : "Capture Screenshot"
                  }
                >
                  <Camera size={22} className="text-white" />
                </button>

                {/* Comments Toggle Button */}
                <button
                  onClick={() => setShowComments(!showComments)}
                  className="w-11 h-11 rounded-full bg-white/10 backdrop-blur-md flex items-center justify-center shadow-lg border border-white/20 hover:bg-white/20 text-white transition-all duration-300 hover:scale-110 active:scale-95 cursor-pointer"
                  title={showComments ? "Hide Comments" : "Show Comments"}
                >
                  {showComments ? <MessageCircleOff size={22} className="text-white" /> : <MessageCircle size={22} className="text-white" />}
                </button>

                {/* Mic Mute Toggle */}
                <button
                  className={`w-11 h-11 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95 shadow-lg border cursor-pointer ${isMuted
                    ? 'bg-red-500/20 border-red-500/50 text-red-500'
                    : 'bg-white/10 border-white/20 text-white hover:bg-white/20'
                    }`}
                  onClick={toggleMic}
                  title={isMuted ? "Unmute Mic" : "Mute Mic"}
                >
                  {isMuted ? <MicOff size={22} /> : <Mic size={22} />}
                </button>
              </div>
            </div>

            {/* Mobile actions (vertical stack) */}
            <div className="lg:hidden absolute right-4 bottom-40 flex flex-col items-center gap-2 z-20 pointer-events-auto">
              <button
                onClick={captureScreenshot}
                disabled={(streamMeta?.remaining_ai_clicks ?? streamMeta?.seller?.remaining_ai_clicks) !== undefined && (streamMeta?.remaining_ai_clicks ?? streamMeta?.seller?.remaining_ai_clicks) <= 0}
                className={`w-[44px] h-[44px] rounded-full backdrop-blur-md flex items-center justify-center shadow-lg border transition-all duration-300 ${
                  (streamMeta?.remaining_ai_clicks ?? streamMeta?.seller?.remaining_ai_clicks) !== undefined && (streamMeta?.remaining_ai_clicks ?? streamMeta?.seller?.remaining_ai_clicks) <= 0
                    ? "bg-gray-500/20 border-gray-400/40 text-gray-400 opacity-50 cursor-not-allowed"
                    : "bg-white/20 border-white/40 text-white hover:bg-black/40 hover:scale-110 active:scale-95 cursor-pointer"
                }`}
                title={
                  (streamMeta?.remaining_ai_clicks ?? streamMeta?.seller?.remaining_ai_clicks) !== undefined && (streamMeta?.remaining_ai_clicks ?? streamMeta?.seller?.remaining_ai_clicks) <= 0
                    ? "Insufficient AI Clicks"
                    : "Capture Screenshot"
                }
              >
                <Camera size={22} className="text-white" />
              </button>
              <button
                onClick={() => setShowComments(!showComments)}
                className="w-[44px] h-[44px] rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center shadow-lg border border-white/40 hover:bg-black/40 text-white transition-all hover:scale-110 active:scale-95 cursor-pointer"
                title={showComments ? "Hide Comments" : "Show Comments"}
              >
                {showComments ? <MessageCircleOff size={22} className="text-white" /> : <MessageCircle size={22} className="text-white" />}
              </button>
              <button
                className={`w-[44px] h-[44px] rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95 shadow-lg border cursor-pointer ${isMuted
                  ? 'bg-red-500/20 border-red-500/50 text-red-500'
                  : 'bg-white/20 border-white/40 text-white hover:bg-black/40'
                  }`}
                onClick={toggleMic}
                title={isMuted ? "Unmute Mic" : "Mute Mic"}
              >
                {isMuted ? <MicOff size={22} /> : <Mic size={22} />}
              </button>
            </div>
            {/* LEFT CONTENT (desktop only) */}
            <div className={`flex-1 hidden lg:flex flex-col justify-between h-[100%] ${showComments ? "w-[calc(100%-400px)]" : "w-full"} pointer-events-none relative`}>
              <div className="live-view-minute pointer-events-auto">
                <div className="flex items-start gap-3 justify-between">
                  <div className="live-view-box flex items-start gap-2">
                    <span className="bg-red-600 text-white text-[16px] px-3 py-1 rounded-full">Live</span>
                    <span className="bg-white text-black text-[16px] px-2 py-[5px] rounded-full flex items-center gap-1">
                      <img src="/images/eye5.svg" alt="eye" /> {totalViewers} views
                    </span>
                    <span className="bg-white text-black text-[16px] px-3 py-[5px] rounded-full flex items-center gap-2 font-semibold">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-[18px] h-[18px]">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
                      </svg>
                      {totalLiked} likes
                    </span>
                  </div>
                  {/* LIKES & TIMER (top-right; shift left when chat open) */}
                  <div className="flex items-end gap-2 z-20">
                    {timeLeft !== null && (
                      <span className={`bg-pink-500 text-white text-sm font-semibold px-3 py-1.5 rounded-full transition-all duration-200 ${timeLeft <= 30 ? "animate-pulse" : ""}`}>
                        {formatTimeLeft(timeLeft)}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {/* Horizontal Products Scroll */}
              {products && products.length > 0 && (
                <div ref={desktopScrollRef} className={`flex ${showComments ? "w-full ml-2 " : " ml-2 w-full"} flex-row flex-nowrap gap-4 overflow-x-auto pb-2 custom-scrollbar pointer-events-none`} style={{ scrollSnapType: 'x mandatory' }}>
                  {products.map((item) => (
                    <div
                      key={item._id}
                      className="bg-white rounded-[10px] p-[10px] min-w-[240px] md:min-w-[200px] max-w-[310px] shadow-md flex items-center gap-3 flex-shrink-0 pointer-events-auto"
                      style={{ scrollSnapAlign: 'start' }}
                    >
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-[70px] h-[70px] object-cover rounded-[10px] flex-shrink-0"
                      />

                      <div className="flex-1 min-w-0 w-[120px]">
                        <h5 className="text-zinc-950 font-bold text-sm truncate">
                          {item?.title}
                        </h5>

                        <p className="text-zinc-950 font-bold text-xs">
                          {item.price ? "INR " + item.price : "INR 0"}
                        </p>

                        <button
                          className="bg-red-400 mt-2 hover:bg-red-500 text-white text-[10px] px-3 py-2 rounded-lg font-bold whitespace-nowrap transition-colors flex-shrink-0"
                          onClick={() => navigate(`/advertiser/product-details?o_id=${item._id}`)}
                        >
                          Get Details
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Mobile + Tablet (<1024): products slider at bottom (match Detail.js) */}
            {products && products.length > 0 && (
              <div className="lg:hidden absolute left-0 right-0 bottom-0 z-1 px-2">
                <div ref={mobileScrollRef} className="flex flex-row gap-1 overflow-x-auto pb-2 custom-scrollbar">
                  {products.map((item) => (
                    <div
                      key={item._id}
                      className="bg-white rounded-2xl p-3 shadow-2xl flex items-center gap-3 min-w-[260px] max-w-[320px] flex-shrink-0"
                    >
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-14 h-14 rounded-xl object-cover flex-shrink-0"
                      />
                      <div className="flex flex-col gap-1 flex-1 min-w-0">
                        <h4 className="text-black font-semibold text-sm truncate">
                          {item?.title}
                        </h4>
                        <p className="text-black text-xs font-semibold">
                          {item.price ? "INR " + item.price : "INR 0"}
                        </p>
                        {(item?.description || "").trim() && (
                          <p className="text-zinc-500 text-[11px] line-clamp-1 mt-0.5 break-words">
                            {item.description}
                          </p>
                        )}
                        <button
                          className="bg-red-400 hover:bg-red-500 text-white text-[11px] px-3 py-2 rounded-lg font-bold whitespace-nowrap transition-colors w-fit mt-1"
                          onClick={() => navigate(`/advertiser/product-details?o_id=${item._id}`)}
                        >
                          Get Details
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* RIGHT SIDE INFO (desktop only, match Detail.js) */}
            {showComments && (

              <div className="hidden lg:flex max-w-[100%] lg:max-w-[457px] flex-col gap-4 justify-between bg-black/40 w-full p-[20px] rounded-[20px] pointer-events-auto">
                <div className="bg-white/20 backdrop-blur-md rounded-2xl p-[12px] flex items-center gap-3">
                  <img 
                    src={sellerMeta?.profile_image || sellerMeta?.store_image || "/images/User.png"} 
                    onError={(e) => { e.target.onerror = null; e.target.src = '/images/User.png'; }}
                    alt="User" 
                    className="w-[50px] h-[50px] shrink-0 rounded-full object-cover border border-white/20" 
                  />
                  <div className="min-w-0 flex-1">
                    <h4 className="text-white text-[14px] font-bold truncate leading-tight">{sellerMeta?.name || "Sarah Miller"}</h4>
                    <span className="text-white/70 text-[11px] truncate">{sellerMeta?.store_name || "Sarah's Boutique"}</span>

                  </div>
                  <div className="shrink-0 ml-auto">
                    <button
                      onClick={() => stopStream()}
                      className="btn btn-pri">
                      End Stream
                    </button>
                  </div>
                </div>


                {/* Comments List */}
                <div
                  ref={chatContainerRef}
                  className="flex-1 overflow-y-auto pr-2 custom-scrollbar flex flex-col gap-2 my-2 min-h-0"
                >
                  {commentLists.length === 0 && (
                    <div className="text-white/40 text-sm text-center py-4">No messages yet.</div>
                  )}
                  {commentLists.map((item, idx) => {
                    if (item.isPrivateReply) {
                      return (
                        <div key={`mpr-${idx}`} className="flex items-start gap-2 mt-1 break-inside-avoid">
                          <img
                            src={item.userData?.profile_image || "/images/User.png"}
                            onError={(e) => { e.target.onerror = null; e.target.src = '/images/User.png'; }}
                            alt="streamer"
                            className="w-7 h-7 rounded-full object-cover shrink-0 ring-1 ring-yellow-400"
                          />
                          <div className="flex flex-col flex-1 min-w-0">
                            {item.replyToMessage && (
                              <div className="bg-white/10 border-l-2 border-yellow-400 px-2 py-1 mb-1 rounded text-[10px] text-white/70 flex items-start gap-1">
                                <CornerDownRight size={9} className="mt-0.5 shrink-0 opacity-60" />
                                <span className="truncate">{item.replyToMessage}</span>
                              </div>
                            )}
                            <span className="text-white font-medium text-sm">
                              {item.senderId?.toString() === userID?.toString()
                                ? "You"
                                : (item.userData?.name || "Viewer")}
                            </span>
                            <span className="text-white/90 text-[11px] break-words whitespace-pre-wrap">
                              {item.message}
                            </span>
                            <span className="text-yellow-400 text-[9px] font-bold mt-0.5">
                              Private reply
                            </span>
                          </div>
                        </div>
                      );
                    }

                    return (
                      <div key={idx} className="flex items-start gap-2">
                        {/* Avatar */}
                        <img
                          src={item.userData?.profile_image || "/images/User.png"}
                          onError={(e) => { e.target.onerror = null; e.target.src = '/images/User.png'; }}
                          alt="user"
                          className="w-6 h-6 rounded-full object-cover shrink-0"
                        />

                        {/* Name + Comment */}
                        <div className="flex flex-col flex-1">
                          <span className="text-white font-medium text-sm">
                            {item.senderId?.toString() === userID?.toString()
                              ? "You"
                              : (item.userData?.name || "Viewer")}
                          </span>

                          <span className="text-white/70 text-xs break-all whitespace-pre-wrap leading-relaxed">
                            {item.title || item.message}
                          </span>
                        </div>

                        {/* Reply Button */}
                        {item.senderId?.toString() !== userID?.toString() && (
                          <button
                            onClick={() =>
                              setReplyTarget({
                                commentId: item._id,
                                senderId: item.senderId,
                                senderName: item.userData?.name || "Viewer",
                                message: item.title || item.message,
                              })
                            }
                            className="text-[10px] text-primary-400 hover:text-white transition-colors shrink-0 px-2 py-0.5 border border-primary-400 rounded-full"
                          >
                            Reply
                          </button>
                        )}
                      </div>
                    );
                  })}

                </div>

                {/* Input area */}
                {streamMeta?.stream_type === "live" && isStreaming && (
                  <div className="mt-auto">
                    {replyTarget ? (
                      <div className="flex flex-col gap-2 mt-2">
                        <div className="flex items-center justify-between text-xs text-white/50 px-1">
                          <span>↩ Replying privately to <span className="text-white font-medium">{replyTarget.senderName}</span></span>
                          <button onClick={() => { setReplyTarget(null); setReplyMessage(""); }} className="text-white/40 hover:text-white text-lg leading-none">×</button>
                        </div>
                        <div className="flex items-center gap-2">
                          <input
                            type="text"
                            placeholder={`Private reply to ${replyTarget.senderName}...`}
                            className="flex-1 bg-white/10 backdrop-blur-md text-white placeholder-white/40 border border-white/20 h-[48px] rounded-full px-5 text-sm transition-all focus:bg-white/20 outline-none"
                            value={replyMessage}
                            onChange={(e) => setReplyMessage(e.target.value)}
                            onKeyDown={(e) => e.key === "Enter" && handleSendReply()}
                            autoFocus
                          />
                          <button
                            onClick={handleSendReply}
                            className="bg-primary-500 w-[48px] h-[48px] rounded-full text-white flex items-center justify-center shrink-0 shadow-lg transition-all hover:scale-110 active:scale-95 hover:bg-primary-600"
                          >
                            <Send size={20} className="ml-0.5" />
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="flex items-center gap-2 mt-2">
                        <input
                          type="text"
                          placeholder="Write here..."
                          className="flex-1 bg-white/10 backdrop-blur-md text-white placeholder-white/40 border border-white/20 h-[48px] rounded-full px-5 text-sm transition-all focus:bg-white/20 outline-none"
                          value={inputMessage}
                          onChange={(e) => setInputMessage(e.target.value)}
                          onKeyDown={(e) => e.key === "Enter" && handleSend()}
                        />
                        <button
                          onClick={handleSend}
                          className="bg-primary-500 w-[48px] h-[48px] rounded-full text-white flex items-center justify-center shrink-0 shadow-lg transition-all hover:scale-110 active:scale-95 hover:bg-primary-600"
                        >
                          <Send size={20} className="ml-0.5" />
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* MOBILE COMMENTS (bottom sheet, match Detail.js) */}
            {showComments && (
              <div className="lg:hidden absolute inset-x-0 bottom-0 top-1/3 bg-black/60 backdrop-blur-md flex flex-col justify-between p-4 pt-3 gap-3 z-30">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <img
                      src={sellerMeta?.profile_image || sellerMeta?.store_image || "/images/User.png"}
                      onError={(e) => { e.target.onerror = null; e.target.src = '/images/User.png'; }}
                      alt="User"
                      className="w-8 h-8 rounded-full object-cover border border-white/30"
                    />
                    <div className="flex flex-col">
                      <span className="text-white text-sm font-semibold leading-tight">
                        {sellerMeta?.name || "Sarah Miller"}
                      </span>
                      <span className="text-white/70 text-[11px] leading-tight">
                        {sellerMeta?.store_name || "Sarah's Boutique"}
                      </span>
                    </div>
                  </div>
                  <button
                    onClick={() => setShowComments(false)}
                    className="text-white/70 text-xs px-2 py-1 rounded-full bg-white/10"
                  >
                    Close
                  </button>
                </div>

                <div
                  ref={chatContainerRef}
                  className="flex-1 overflow-y-auto pr-1 custom-scrollbar flex flex-col gap-2 my-1"
                >
                  {commentLists.length === 0 && (
                    <div className="text-white/40 text-xs text-center py-4">No messages yet.</div>
                  )}
                  {commentLists.map((item, idx) => {
                    if (item.isPrivateReply) {
                      return (
                        <div key={`mpr-mob-${idx}`} className="flex items-start gap-2 mt-1 break-inside-avoid">
                          <img
                            src={item.userData?.profile_image || "/images/User.png"}
                            onError={(e) => { e.target.onerror = null; e.target.src = '/images/User.png'; }}
                            alt="streamer"
                            className="w-7 h-7 rounded-full object-cover shrink-0 ring-1 ring-yellow-400"
                          />
                          <div className="flex flex-col flex-1 min-w-0">
                            {item.replyToMessage && (
                              <div className="bg-white/10 border-l-2 border-yellow-400 px-2 py-1 mb-1 rounded text-[10px] text-white/70 flex items-start gap-1">
                                <CornerDownRight size={9} className="mt-0.5 shrink-0 opacity-60" />
                                <span className="truncate">{item.replyToMessage}</span>
                              </div>
                            )}
                            <span className="text-white font-medium text-[12px]">
                              {item.senderId?.toString() === userID?.toString()
                                ? "You"
                                : (item.userData?.name || "Viewer")}
                            </span>
                            <span className="text-white/90 text-[11px] break-words whitespace-pre-wrap">
                              {item.message}
                            </span>
                            <span className="text-yellow-400 text-[9px] font-bold mt-0.5">
                              Private reply
                            </span>
                          </div>
                        </div>
                      );
                    }

                    return (
                      <div key={idx} className="flex items-start gap-2">
                        <img
                          src={item.userData?.profile_image || "/images/User.png"}
                          onError={(e) => { e.target.onerror = null; e.target.src = '/images/User.png'; }}
                          alt="user"
                          className="w-7 h-7 rounded-full object-cover shrink-0 border border-white/10"
                        />
                        <div className="flex flex-col flex-1 min-w-0">
                          <span className="text-white font-medium text-[12px]">
                            {item.senderId?.toString() === userID?.toString()
                              ? "You"
                              : (item.userData?.name || "Viewer")}
                          </span>
                          <span className="text-white/70 text-[11px] break-all whitespace-pre-wrap leading-relaxed">
                            {item.title || item.message}
                          </span>
                        </div>
                        {item.senderId?.toString() !== userID?.toString() && (
                          <button
                            onClick={() =>
                              setReplyTarget({
                                commentId: item._id,
                                senderId: item.senderId,
                                senderName: item.userData?.name || "Viewer",
                                message: item.title || item.message,
                              })
                            }
                            className="text-[10px] text-primary-300 hover:text-white transition-colors shrink-0 px-2 py-0.5 border border-primary-300 rounded-full"
                          >
                            Reply
                          </button>
                        )}
                      </div>
                    );
                  })}
                </div>

                {replyTarget ? (
                  <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between text-xs text-white/50 px-1">
                      <span>↩ Replying privately to <span className="text-white font-medium">{replyTarget.senderName}</span></span>
                      <button onClick={() => { setReplyTarget(null); setReplyMessage(""); }} className="text-white/40 hover:text-white text-lg leading-none">×</button>
                    </div>
                    <div className="flex items-center gap-2">
                      <input
                        type="text"
                        placeholder={`Private reply to ${replyTarget.senderName}...`}
                        className="flex-1 bg-white/10 backdrop-blur-md text-white placeholder-white/40 border border-white/20 h-[42px] rounded-full px-4 text-xs transition-all focus:bg-white/20 outline-none"
                        value={replyMessage}
                        onChange={(e) => setReplyMessage(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && handleSendReply()}
                        autoFocus
                      />
                      <button
                        onClick={handleSendReply}
                        className="bg-primary-500 w-[42px] h-[42px] rounded-full text-white flex items-center justify-center shrink-0 shadow-lg transition-all hover:scale-110 active:scale-95 hover:bg-primary-600"
                      >
                        <Send size={18} className="ml-0.5" />
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="flex items-center gap-2">
                    <input
                      type="text"
                      placeholder="Write here..."
                      className="flex-1 bg-white/10 backdrop-blur-md text-white placeholder-white/40 border border-white/20 h-[42px] rounded-full px-4 text-xs transition-all focus:bg-white/20 outline-none"
                      value={inputMessage}
                      onChange={(e) => setInputMessage(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && handleSend()}
                    />
                    <button
                      onClick={handleSend}
                      className="bg-primary-500 w-[42px] h-[42px] rounded-full text-white flex items-center justify-center shrink-0 shadow-lg transition-all hover:scale-110 active:scale-95 hover:bg-primary-600"
                    >
                      <Send size={18} className="ml-0.5" />
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveStreamDetail;
